import { NavBar, Collapse } from "bootstrap";
import "@lottiefiles/lottie-player";

import Header from "./header";

Header();